import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducers/index'
import thunk from 'redux-thunk';

function ConfigureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk)
    );
}

export default ConfigureStore;